export default "__VITE_ASSET__DwHFEe3n__"